<template>
  <div class="left">
    <div
      class="research"
      v-if="keyWordList.length || instList.length || (topSubjectsList.length&& highSearchClone)"
    >
      <div class="resarch-theme">
        <span>当前检索条件</span>
        <el-tag closable type="info" @close="closeAll">全部清空</el-tag>
      </div>
      <div class="condition" v-if="topSubjectsList.length && highSearchClone">
        <span>学科</span>
        <el-tag
          v-for="(tag,index) in topSubjectsList"
          @close="closeKey2(tag)"
          :key="index"
          closable
          type="info"
        >{{tag.key||tag}}</el-tag>
      </div>
      <div class="condition" v-if="keyWordList.length">
        <span>研究主题</span>
        <el-tag
          v-for="(tag,index) in keyWordList"
          @close="closeKey(tag)"
          :key="index"
          closable
          type="info"
        >{{tag.key||tag}}</el-tag>
      </div>
      <div class="condition" v-if="instList.length">
        <span>关联机构</span>
        <el-tag
          v-for="(tag,index) in instList"
          :key="index"
          closable
          type="info"
          @close="closeInst(tag)"
        >{{tag}}</el-tag>
      </div>
    </div>
    <div class="border" v-if="keyWordList.length || instList.length"></div>
    <div class="research" v-if="topSubjectsClone.length && highSearchClone">
      <div class="resarch-theme">
        <span>学科</span>
        <el-tag v-if="topSubjectMoreShow" @click="seeMore">
          {{topSubjectMore?'展开更多':'收起'}}
          <i
            :class="[topSubjectMore?'el-icon-arrow-down':'el-icon-arrow-up']"
          ></i>
        </el-tag>
      </div>
      <div class="simkeyword segment hone" v-loading="isClick" v-if="radio1 === '中文'">
        <!--  -->
        <div
          :class="['simkeywords',  topSubjectMore?'top-subject':'' ]"
          :style="{height:isClick?'110px':'auto'}"
          ref="subjectList"
        >
          <el-tag
            v-for="(tag,index) in subjectList"
            :key="tag.key"
            :effect="tag.choose?'dark':'plain'"
            :closable="tag.choose"
            @click="subjectKey(index)"
            @close="closeKey2(tag.key)"
            type="info"
          >{{tag.key}}</el-tag>
          <p class="no-data" v-if="!subjectList.length">暂无数据</p>
        </div>
      </div>
    </div>
    <div class="research" v-if="keyList ">
      <div class="resarch-theme">
        <span>
          研究主题
          <m-tips title="研究主题" content="研究主题来自检索结果中学者的研究关键词统计分析。"></m-tips>
        </span>
      </div>
      <div class="simkeyword segment hone" v-if="radio1 === '中文'">
        <div class="simkeywords" v-loading="isClick">
          <el-tag
            v-for="(tag,index) in keyList"
            :key="tag.key"
            :effect="tag.choose?'dark':'plain'"
            :closable="tag.choose"
            @click="clkKey(index)"
            @close="closeKey(tag.key)"
            type="info"
          >{{tag.key}}</el-tag>
          <p class="no-data" v-if="!keyList.length">暂无数据</p>
        </div>
      </div>
    </div>
    <div class="research" v-else v-loading="loading2"></div>
    <div class="border" v-if="topOrganizations "></div>
    <div class="research" v-if="topOrganizations">
      <div class="resarch-theme">
        <span>
          关联机构
          <m-tips title="关联机构" content="关联机构来自检索结果中学者成果的合作机构统计分析。"></m-tips>
        </span>
      </div>
      <div class="scholars">
        <el-checkbox-group
          class="scholars-related"
          @change="clkSch"
          v-model="instList"
          :disabled="isClick"
        >
          <el-checkbox
            class="checked"
            v-for="(item,index) in organizations"
            :key="index"
            :label="item.key"
          >
            {{item.key}}
            <div class="scholars-bar">
              <div
                :style="{width: (item.doc_count / organizations[0].doc_count * 100)+'%'}"
                class="scholars-bars"
              ></div>
            </div>
          </el-checkbox>
        </el-checkbox-group>
        <p class="no-data" v-if="!topOrganizations.length">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
let startYear = 0;
import mTips from "@/components/m-tips/m-tips";
export default {
  name: "retrieveLeft",
  components: {
    mTips
  },
  props: {
    topKeywords: {
      type: Array
    },
    isLeftClick: {
      type: Boolean,
      required: true
    },
    topOrganizations: {
      type: Array
    },
    topSubjects: {
      type: Array
    },
    typeList: {
      type: Array
    }
  },
  computed: {
    highSearchClone() {
      return this.$store.state.highSearch;
    },
    topKeywordsClone: {
      get() {
        return this.topKeywords;
      },
      set() {}
    },
    topSubjectsClone: {
      get() {
        return this.topSubjects;
      },
      set() {}
    }
  },
  watch: {
    highSearchClone(val) {},
    topSubjectsClone: {
      deep: true,
      handler(val) {
        this.getSubject();
      }
    },
    topKeywordsClone: {
      deep: true,
      handler(val) {
        this.getKey();
        this.loading = false;
      }
    },
    isLeftClick: {
      deep: true,
      handler(val) {
        this.isClick = val;
      }
    },
    startYear: {
      deep: true,
      handler(val) {
        this.endDate = {
          disabledDate(time) {
            let year = startYear + 31622400000;
            return (
              time.getTime() < year || time.getTime() > new Date() - 8.46e7
            );
          }
        };
      }
    },
    topOrganizations: {
      deep: true,
      handler() {
        this.getOrganizations();
        this.loading = false;
      }
    }

    // topKeywords: {
    //   deep: true,
    //   handler () {

    //   }
    // }
  },
  data() {
    return {
      date1: "",
      date2: "",
      radio1: "中文",
      radio2: "中文",
      loading: false,
      loading1: false,
      loading2: false,
      isClick: false,
      keyList: [],
      subjectList: [],
      instList: [],
      isRes: true,
      keyWordList: [],
      topSubjectsList: [],
      topSubjectMore: false,
      topSubjectMoreShow: false,
      startYear: 0,
      startDate: {
        disabledDate(time) {
          return (
            time.getTime() < 631123200000 ||
            time.getTime() > new Date() - 8.46e7 * 365
          );
        }
      },
      endDate: {
        disabledDate(time) {
          let year = startYear + 31622400000;
          return time.getTime() < year || time.getTime() > new Date() - 8.46e7;
        }
      },
      organizations: [],
      coauthors: [],
      isCode: true,
      localIndex: 99,
      subjectIndex: 99
    };
  },
  methods: {
    seeMore() {
      this.topSubjectMore = !this.topSubjectMore;
    },
    startTime(val) {
      startYear = val.getTime();
      this.startYear = startYear;
    },

    subjectKey(index) {
      debugger;
      if (this.subjectList[index].choose === true) {
        return;
      }
      this.subjectList[index].choose = true;
      this.topSubjectsList.push(this.subjectList[index].key);
      this.subjectIndex = index;
      this.getData(0);
    },
    delSubject(val) {
      this.getData(0);
    },

    clkKey(index) {
      debugger;
      if (this.keyList[index].choose === true) {
        return;
      }
      this.keyList[index].choose = true;
      this.keyWordList.push(this.keyList[index].key);
      this.localIndex = index;
      this.getData(0);
    },
    clkSch(val) {
      this.getData(0);
    },
    closeKey2(val) {
      let indexn = 0;
      this.topSubjectsList.forEach((item, index) => {
        if (item.key === val) {
          indexn = index;
          this.topSubjectsList[index].choose = false;
        }
      });
      let i = this.topSubjectsList.findIndex(item => {
        if (item === val) {
          return true;
        }
      });
      this.topSubjectsList.splice(i, 1);
      this.subjectIndex = indexn;
      this.getData();
    },
    closeKey(val) {
      let indexn = 0;
      this.keyList.forEach((item, index) => {
        if (item.key === val) {
          indexn = index;
          this.keyList[index].choose = false;
        }
      });
      let i = this.keyWordList.findIndex(item => {
        if (item === val) {
          return true;
        }
      });
      this.keyWordList.splice(i, 1);
      this.localIndex = indexn;
      this.getData();
    },
    closeInst(name) {
      let i = this.instList.findIndex(item => {
        if (item === name) {
          return true;
        }
      });
      console.log(1);

      this.instList.splice(i, 1);
      this.getData();
    },
    // 全部清空
    closeAll() {
      this.instList = [];
      this.keyWordList = [];
      this.keyList.forEach((item, index) => {
        this.keyList[index].choose = false;
      });

      this.topSubjectsList = [];
      this.subjectList.forEach((item, index) => {
        this.subjectList[index].choose = false;
      });

      this.getData();
    },
    getKey() {
      // if (this.keyList.length) {
      //   return
      // }
      let keyList = [];
      this.topKeywordsClone.forEach((item, index) => {
        item.choose = false;
        keyList.push(item);
      });
      this.keyList = keyList;
    },
    getSubject() {
      let subjectList = [],
        that = this;
      this.topSubjectsClone.forEach((item, index) => {
        item.choose = false;
        subjectList.push(item);
      });
      this.subjectList = subjectList;
      that.isClick = true;
      this.topSubjectMore = false;
      this.topSubjectMoreShow = false;
      this.$nextTick(() => {
        setTimeout(() => {
          that.topSubjectMoreShow = false;
        }, 0);
        var h1 = that.$refs.subjectList
          ? that.$refs.subjectList.offsetHeight
          : 0;
        console.log("h1", h1);
        that.$nextTick(() => {
          setTimeout(() => {
            var h3 = that.$refs.subjectList
              ? that.$refs.subjectList.offsetHeight
              : 0;
            console.log("h3", h3);
            if (h3 > 110) {
              that.topSubjectMoreShow = true;
              that.topSubjectMore = true;
            } else {
              console.log(that.topSubjectMoreShow);
              that.topSubjectMoreShow = false;
            }
          }, 500);
          that.isClick = false;
        });
      });
    },
    getData() {
      // this.loading = true
      debugger;
      let data = {};
      this.isClick = true;
      data = {
        i: this.instList,
        ks: this.keyWordList,
        c: this.collList,
        s: this.topSubjectsList
      };
      this.$emit("screenData", data);
    },
    getOrganizations() {
      this.organizations = [];
      this.topOrganizations.forEach((item, index) => {
        if (item.key.split(";").length === 1) {
          this.organizations.push(item);
        } else {
          let temp = item.key.split(";");
          temp.forEach(element => {
            let list = {
              key: element,
              doc_count: item.doc_count
            };
            this.organizations.push(list);
          });
        }
      });
    },
    setScreen(data) {
      if (data !== 999) {
        this.instList = data.i;
        if (this.localIndex !== 99) {
          this.keyList[this.localIndex].choose = !this.keyList[this.localIndex]
            .choose;
          this.keyWordList = data.ks;
        }
        this.localIndex = 99;
      }
      this.localIndex = 99;
    }
  },
  mounted() {
    if (this.topOrganizations) {
      this.getOrganizations();
    }
    if (!this.topKeywords) {
      this.loading = true;
    } else {
      this.getKey();
    }
    if (!this.topKeywords) {
      this.loading = true;
    } else {
      this.getSubject();
    }
  }
};
</script>

<style lang="scss">
.left {
  padding: 10px;
  background: #fff;
  padding-right: 2%;
  width: 30%;
  margin-right: 1%;
  .border {
    margin: 30px 0;
    border-top: 1px solid #000000;
  }
  .date {
    margin-top: 20px;
    .datePicker {
      margin: 0 10px;
      width: 30%;
    }
  }
  .research {
    width: 100%;
    .resarch-theme {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      span {
        font-weight: 700;
      }
      .ridio {
        margin-top: -10px;
      }
    }

    .condition {
      margin-top: 20px;
      .el-tag {
        margin: 0 5px 5px 5px;
      }
    }

    .simkeyword {
      margin-top: 20px;
      .simkeywords {
        padding: 10px 0;
        .el-tag {
          cursor: pointer;
          margin: 4px 5px;
          max-width: 90%;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          overflow: hidden;
        }
        .el-zoom-in-center-leave-active {
          height: 0;
          margin: 0;
          width: 0;
          padding: 0;
        }
      }

      .top-subject {
        max-height: 100px;
        overflow-y: hidden;
      }
    }
    .more {
      text-align: center;
      font-weight: 800;
    }
    .scholars {
      margin-bottom: 20px;
      .checked {
        margin-top: 10px;
        display: flex;
        min-width: 300px;
        width: 20vw;
        align-items: center;
        .el-checkbox__label {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .scholars-bar {
        min-width: 300px;
        width: 20vw;
        height: 10px;
        background: #e0e0e0;
        .scholars-bars {
          height: 10px;
          background: #76877d;
        }
      }
    }
  }
}
.no-data {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/commonrRetrieve/left.vue